import { css } from '@emotion/css';
import colors from '@/theme/colors';

const styles = {
  container: css`
    display: flex;
    flex-direction: column;
    padding: 16px;
    gap: 16px;
  `,
  languageContainer: css`
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-items: center;
    margin: 24px 0px 26px 0px;
    text-decoration: none;
    color: ${colors.prussian};
    cursor: pointer;
  `,
  content: css`
    display: flex;
    flex-direction: row;
  `,
  languagesContainer: css`
    display: flex;
    flex-direction: column;
    margin-top: 10px;
    margin-bottom: 32px;
  `,
  languageListContainer: css`
    width: 100%;
  `,
  languageItem: css`
    margin: 8px 0px 8px 16px;
    cursor: pointer;
  `,
  language: css`
    width: 103%;
    padding: 2px 16px 2px 0px;
    :hover {
      margin-left: -16px;
      padding: 2px 16px 2px 16px;
      background-color: ${colors.platinum};
      border-radius: 5px;
    }
  `,
  selectedLanguageContainer: css`
    display: flex;
    justify-content: space-between;
    align-items: center;
  `,
  selectedLanguage: css`
    padding: 16px 0px 8px 16px;
  `,
  checkIcon: css`
    color: ${colors.prussian};
    margin-top: 8px;
    margin-right: 16px;
  `,
  searchIcon: css`
    color: ${colors.prussian};
  `,
};

export default styles;
